const CONFIG = {
    // 开发环境配置
    development: {
        baseUrl: 'http://127.0.0.1:9085', // 后台接口请求地址
        detectionUrl: 'https://api.konghaojiance.vip',
        hostUrl: 'http://127.0.0.1:3000', // PC地址(前端运行地址)
        agentMode : !!window._CONFIG.agentMode
    },
    // 生产环境配置
    production: {
        baseUrl: window._CONFIG.baseUrl ? window._CONFIG.baseUrl : 'http://api.message333.com', // 后台接口请求地址
        detectionUrl: window._CONFIG.detectionUrl ? window._CONFIG.detectionUrl : 'https://api.konghaojiance.vip',
        hostUrl: 'http://www.message333.com', // PC地址(前端运行地址),
        agentMode : !! window._CONFIG.agentMode
    }
};

const ENV_CONFIG =  CONFIG[process.env.NODE_ENV];
export default ENV_CONFIG

export const useAgentMode = ENV_CONFIG.agentMode
